<template>
  <div class="order-box">
    <div class="order-content">
      <div class="list">
        <ul>
          <li>
            <p :class="{'order-title': item.orderInfo.orderStatus == 2}" :title="item.orderInfo.orderName">
              <b>订单名称：{{item.orderInfo.orderName}}</b>
              <span :class="{success: item.statue == 5}">状态：<i>{{item.orderInfo.orderStatus | statue}}</i></span>
            </p>
            <div class="Order">
              <p>订单编号：{{item.orderInfo.orderNo}}</p>
              <div v-if="item.orderInfo.orderStatus == 5">
                <p>支付类型：{{item.orderInfo.payType == 1?'线上支付':'线下支付'}}</p>
                <p v-if="item.orderInfo.payType == 1">支付方式：微信</p>
              </div>
              <p><b>缴费时间：{{item.orderInfo.payTime}}</b><span>缴费金额：<i>{{item.orderInfo.amount}}</i></span></p>
              <div class="voucher" v-if="item.orderInfo.offlineVoucher">
                <p>缴费凭证：<font @click="onChangeImg" style="color:#107BDA">点击查看</font>
                  <span style="color:#107bda" v-if="item.orderAudit&&item.orderAudit.reason"
                    @click="go('OfflinePayment')">查看审核意见</span>
                </p>
                <van-image-preview v-model="showImg" :images="images" :show-index='showIndex' :closeable='closeable'
                  @close="onClose" v-loading="loading">
                  <!-- 自定义加载效果 -->
                </van-image-preview>

              </div>
            </div>
            <div class="buttonBox" v-if="item.orderInfo.orderStatus == 2">
              <span @click="cancel" v-if="!item.orderAudit" class="orderBton">取消订单</span>
              <p>
                <van-button type="info" @click="onLine" v-if="isWXPay">线上支付</van-button>
                <van-button plain type="primary" @click="go('OfflinePayment','提交')">线下支付</van-button>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <van-popup v-model="auditPopup" class="audItPop" style="width:80%">
      <h4>建议</h4>
      <div style="text-align: center;line-height: 120px;font-size: 13px">
        {{item.orderAudit && item.orderAudit.reason}}
      </div>
      <div class="popupSub" @click="close()">关闭</div>
    </van-popup>
  </div>
</template>

<script>
  import { getPZUrl, paymentCancel, cancelMeetingOrder } from "@/api/dictionary";
  import { Uploader, Toast, Button, Dialog, Popup, Lazyload } from "vant";
  export default {
    props: {
      item: {
        type: Object,
        default: () => { }
      },
      from: {
        type: String,
        default: ""
      },
      isWXPay: {
        type: Boolean,
        default: true
      },
      paymentDisabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        images: [],
        showImg: false,
        auditPopup: false,
        closeable: true,
        showIndex: false,
        loading: false
      };
    },
    filters: {
      statue(val) {
        switch (val) {
          case 1:
            return "已删除";
            bredk;
          case 2:
            return "待支付";
            bredk;
          case 3:
            return "已取消";
            bredk;
          case 4:
            return "已支付";
            bredk;
          case 5:
            return "订单完成";
            bredk;
        }
      }
    },
    components: {
      [Uploader.name]: Uploader,
      [Toast.name]: Toast,
      [Button.name]: Button,
      [Dialog.name]: Dialog,
      [Popup.name]: Popup,
      [Lazyload.name]: Lazyload,

    },
    methods: {
      close() {
        // console.log(2222)
        this.auditPopup = false;
      },
      go(pathName, sub) {
        if (this.paymentDisabled && pathName === 'OfflinePayment') {
          return Toast.fail('请先取消权利会员申请后再缴费')
        }
        console.log(this.item);
        if (this.item.orderAudit && this.item.orderAudit.result === 2 || this.item.orderAudit && this.item.orderAudit.result === 3) {
          this.auditPopup = true;

        }
        if (!this.item.orderAudit) {
          let params = {};
          params.orderId = this.item.orderInfo.id;
          this.$router.push({ name: pathName, query: params });
        }
        if (sub) {
          let params = {};
          params.orderId = this.item.orderInfo.id;
          this.$router.push({ name: pathName, query: params });
        }
      },
      onClose() {
        this.images = []
      },
      onChangeImg() {
        this.showImg = true;
        this.getDisplay();

      },
      //获取凭证
      getDisplay() {
        this.loading = true
        this.images = []
        let params = {
          id: this.item.orderInfo.offlineVoucher
        };
        if (!this.item.orderInfo.offlineVoucher) return;
        getPZUrl(params).then(res => {
          if (res.success) {
            this.loading = false
            this.images.push(res.result.toString())
          } else {
            this.loading = false
          }
        });
      },
      show() {
        const viewer = this.$el.querySelector(".images").$viewer;
        viewer.show();
      },
      onLine() {
        if (this.paymentDisabled) return Toast.fail('请先取消权利会员申请后再缴费')
        this.$emit("onLine", this.item.orderInfo);
      },
      underLine() {
        this.$router.push({
          name: "payUndeLine",
          params: { id: this.item.orderInfo.id },
          query: { form: this.from }
        });
      },
      cancel() {
        let params = {
          orderId: this.item.orderInfo.id
        };
        Dialog.confirm({
          title: '提示',
          message: '确认取消订单？',
        }).then(() => {
          if (this.from == "meetingUndeLine") {
            this.meetingCancel(params);
          } else {
            this.paymentCancel(params);
          }
        })
      },
      paymentCancel(params) {
        paymentCancel(params).then(res => {
          Toast.success("取消成功！");
          this.$emit("getDate", this.item);
        });
      },
      meetingCancel(params) {
        cancelMeetingOrder(params).then(res => {
          if (res.success) {
            this.$emit("getDate", this.item);
          } else {
            Toast.fail("创建订单失败");
          }
        });
      },
      deleteOrder() {
        let params = {
          meetingId: this.item.meeting.id,
          memberId: sessionStorage.getItem("memberId")
        };
        this.$confirm("确认删除订单?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            deleteMeetingOrder(params).then(res => {
              if (res.success) {
                this.$emit("update");
              } else {
                Toast.fail("创建订单失败");
              }
            });
          })
          .catch(() => { });
      }
    },
    mounted() { }
  };
</script>

<style scoped lang="less">
  .content ul li {
    border-bottom: #f2f2f2 solid 8px;
    padding: 20px 0 15px 0;

    p {
      overflow: hidden;
      padding: 0 20px;
      height: 36px;

      b {
        float: left;
        display: block;
        width: 67%;
        line-height: 28px;
      }

      span {
        display: block;
        float: right;
        font-size: 14px;
        line-height: 28px;

        i {
          color: #ea4848;
        }
      }
    }
  }

  .Order {
    background: #fafafa;
    padding: 15px 0;
  }

  .Order p {
    line-height: 32px;
    color: #848484;
    font-size: 14px;
  }

  .fontsBox {
    width: 84%;
    margin: 20px auto 0 auto;
    background: #fff6ec;
    padding: 14px;
    font-size: 13px;
    border: #f6d0a2 dashed 1px;
    line-height: 22px;
    color: #ffbe4e;
  }

  .imgBox {
    padding: 20px;

    img {
      width: 100%;
    }
  }

  /deep/.van-nav-bar .van-icon {
    color: #fff;
  }

  .buttonBox {
    margin-top: 15px;
    overflow: hidden;
    height: 36px;
    display: flex;

    .van-button {
      border: none;
      height: 35px;
      line-height: 30px;
      margin: 0 5px;
      width: 100%;
    }

    p {
      float: right;
      width: 100%;
      display: flex;
    }
  }

  /deep/ .buttonBox>.orderBton {
    height: 35px;
    line-height: 30px;
    display: block;
    text-align: center;
    width: 50%;
  }

  .van-button--plain.van-button--primary,
  .van-button--info {
    border: 1px solid #228ccd !important;
  }

  .images {
    margin-left: 20px;
  }

  .voucher img {
    width: 80px;
    height: 30px;
  }

  .audItPop {
    padding-top: 30px;
    border-radius: 16px;
  }

  .audItPop h4 {
    font-size: 16px;
    text-align: center;
  }

  .popupSub {
    text-align: center;
    color: red;
    border-top: #eee solid 1px;
    font-size: 16px;
    padding: 20px
  }

  .custom-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    user-select: none;
  }
</style>
